import React from "react";
import { connect } from "react-redux";
import { Segment, Header, Button } from "semantic-ui-react";
import FormNuevaCita from "./ventasNuevaCita/FormNuevaCita";
import TablaCitas from "./ventasNuevaCita/TablaCitas";
import { ventasCitasOps } from "../../ducks/ventasCitas";

class VentasNuevaCita extends React.Component {
  state = {
    visibleFormNuevo: false,
    editCita: null
  };

  componentDidMount() {
    this.props.attachListenersCitasDeVenta(this.props.match.params.idColegio);
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataSaved.status) {
      this.props.resetDataSaved();
    }
  }

  componentWillUnmount() {
    // this.props.quitarColegioSeleccionado();
    this.props.limpiarCitasDeVenta();
    this.props.detachListenersCitasDeVenta();
  }

  handleVolver = () => this.props.history.goBack();

  handleMostrarFormulario = () =>
    this.setState(state => ({ visibleFormNuevo: true }));

  handleDescartar = () => this.resetState();

  handleAddCita = values => {
    this.props.addNuevaCitaDeVenta({
      idColegio: this.props.match.params.idColegio,
      ...values,
      uid: this.props.user.uid,
      isEdit: this.state.editCita !== null,
      completada: false
    });
    this.resetState();
  };

  handleBorrarCita = idCita => this.props.borrarCitaDeVenta({ idCita });

  handleEditCita = idCita =>
    this.setState(state => ({
      visibleFormNuevo: true,
      editCita: this.props.citasDeVenta.filter(({ id }) => id === idCita)[0]
    }));

  handleCompletarCita = idCita => this.props.completarCitaDeVenta({ idCita });

  resetState = () =>
    this.setState(state => ({
      visibleFormNuevo: false,
      editCita: null
    }));

  render() {
    const { colegioSeleccionado, citasDeVenta } = this.props;
    return (
      <Segment>
        <Segment basic>
          <Button
            content="Cerrar"
            floated="right"
            color="pink"
            icon="cancel"
            onClick={this.handleVolver}
          />
          <Header
            as="h3"
            content={colegioSeleccionado && colegioSeleccionado.nombreColegio}
          />
        </Segment>

        <Segment basic>
          <Button
            content="Añadir Nueva Cita"
            color="pink"
            icon="add"
            disabled={this.state.visibleFormNuevo}
            onClick={this.handleMostrarFormulario}
          />
          {this.state.visibleFormNuevo && (
            <Segment>
              <FormNuevaCita
                handleAddCita={this.handleAddCita}
                handleDescartar={this.handleDescartar}
                initialValues={this.state.editCita}
              />
            </Segment>
          )}
        </Segment>
        <Segment>
          <Header as="h3" content="Citas" />
          <TablaCitas
            datos={citasDeVenta}
            handleBorrarCita={this.handleBorrarCita}
            handleEditCita={this.handleEditCita}
            handleCompletarCita={this.handleCompletarCita}
          />
        </Segment>
      </Segment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.session.user,
  dataSaved: state.ventasCitas.dataSaved,
  colegioSeleccionado: state.ventas.colegioSeleccionado,
  citasDeVenta: state.ventasCitas.citasDeVenta
});

const mapDispatchToProps = {
  attachListenersCitasDeVenta: ventasCitasOps.attachListenersCitasDeVenta,
  detachListenersCitasDeVenta: ventasCitasOps.detachListenersCitasDeVenta,
  resetDataSaved: ventasCitasOps.resetDataSaved,
  limpiarCitasDeVenta: ventasCitasOps.limpiarCitasDeVenta,
  addNuevaCitaDeVenta: ventasCitasOps.addNuevaCitaDeVenta,
  borrarCitaDeVenta: ventasCitasOps.borrarCitaDeVenta,
  completarCitaDeVenta: ventasCitasOps.completarCitaDeVenta
};

export default connect(mapStateToProps, mapDispatchToProps)(VentasNuevaCita);



// WEBPACK FOOTER //
// ./src/pages/ventas/VentasNuevaCita.jsx